import EventScorekeepingDelete from '@/screens/EventScorekeepingDelete';

export default function PrivateEventEventIdScoreDeleteIndexRoute() {
  return <EventScorekeepingDelete />;
}
